import React from "react";

export default function Cart({ cart }) {
  const total = cart.reduce((sum, item) => sum + item.price, 0);

  return (
    <div className="container mt-4">
      <h3>Cart</h3>
      {cart.length === 0 ? <p>No items</p> : null}

      {cart.map((item, index) => (
        <div key={index} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
        <img src={item.img} alt={item.name} width="260"   height="260"  />
         <p> {} - {item.name} - ₹{item.price}</p>
        </div>
      ))}

      <h4>Total: ₹{total}</h4>
    </div>
  );
}